import script from "./EcommerceTermsConditions.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceTermsConditions.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceTermsConditions.vue?vue&type=style&index=0&id=b3d02f64&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3d02f64"]])

export default __exports__